import PropTypes from "prop-types"
import React from "react"

import Loader from "src/components/Loader"
import Pagination from "src/components/Pagination"

import ChatThreadEmptyState from "./ChatThreadEmptyState"
import ChatThreadFilters from "./ChatThreadFilters"
import ChatThreadRow from "./ChatThreadRow"

const ChatThreadList = ({
  items,
  isLoading = false,
  showFilters = false,
  filters,
  onFilterChange,
  pagination,
  onPageChange,
  emptyState,
}) => {
  if (isLoading) {
    return <Loader name="chat-threads" />
  }

  return (
    <div>
      {showFilters && (
        <ChatThreadFilters
          readStatus={filters?.readStatus || "all"}
          selectedTypes={filters?.types || []}
          onReadStatusChange={(value) =>
            onFilterChange?.({ ...filters, readStatus: value })
          }
          onTypesChange={(value) =>
            onFilterChange?.({ ...filters, types: value })
          }
          onReset={() => onFilterChange?.({ readStatus: "all", types: [] })}
        />
      )}

      {items.length === 0 ? (
        <ChatThreadEmptyState
          title={emptyState?.title || "No messages"}
          description={emptyState?.description}
          icon={emptyState?.icon}
        />
      ) : (
        <>
          <div>
            {items.map((item, index) => (
              <div key={`${item.type}-${item.id}`}>
                <ChatThreadRow {...item} />
                {index < items.length - 1 && (
                  <hr className="my-2 w-full border-b" />
                )}
              </div>
            ))}
          </div>

          {pagination && pagination.pageCount > 1 && (
            <nav className="mt-4">
              <Pagination
                numberOfPages={pagination.pageCount}
                page={pagination.page}
                onPageChange={onPageChange}
              />
            </nav>
          )}
        </>
      )}
    </div>
  )
}

ChatThreadList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      detailPath: PropTypes.string.isRequired,
    })
  ).isRequired,
  isLoading: PropTypes.bool,
  showFilters: PropTypes.bool,
  filters: PropTypes.shape({
    readStatus: PropTypes.string,
    types: PropTypes.arrayOf(PropTypes.string),
  }),
  onFilterChange: PropTypes.func,
  pagination: PropTypes.shape({
    page: PropTypes.number,
    pageCount: PropTypes.number,
    totalCount: PropTypes.number,
  }),
  onPageChange: PropTypes.func,
  emptyState: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.string,
  }),
}

export default ChatThreadList
